import React, { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import '../../../common/report/reports/Invoice/invoice-table.component.css'
import ManageInvoice from "./manage-invoice.component";
import { DataTable } from "../../../common/table/data-table/data-table-component";
import ButtonIcon from "../../../button";
import { CustomColumns } from "../../../common/modal-popover/custom-columns";
import header from "../../../common/sample-data/header";
import Filter from "../../../common/filter/filter.component";
export class ExterNalInvoice extends Component {
    constructor(props) {
        super(props);
        this.DisplaySearhBox=this.DisplaySearhBox.bind(this)
        this.openLineItem=this.openLineItem.bind(this)
        this.state={
            tableSelected:false,
            closeForm:false,
            pageNumber:0,
			viewType:'list',            
            displaySearch:false
        }
      }

      DisplaySearhBox() {
        this.setState({displaySearch:!this.state.displaySearch})
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }

    CloseForm(data) {
        this.setState({tableSelected:data})
    }

    render() {
       
        const pages={
            HasNext: true,
            HasPrevious: false,
            PageNumber: this.state.pageNumber,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123
        }

        const secondList={
            Headers:[
                {
                 
                }
              ]
         };
        
        return(
            <div className="invoice-wrapper-container" >
                <RequestHeaders headerTitle="Invoices" />
                {this.state.tableSelected ?
                    <ManageInvoice closeForm={this.CloseForm.bind(this)}/>
                     :                   
                     <div className="request-table data-table request-table-invoice fit-width">
                        <Filter data={[]}/>
                        <div className="horizontal-separator"></div>
                        <div className="container-filter-button">
                            <ButtonIcon onClick={this.DisplaySearhBox} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-filter-button" labelName="Search"/>                      
                            <CustomColumns firstList={header.Headers} secondList={secondList.Headers}/>                         
                                                    
                            <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-filter-button" labelName="Extract List"/>
                        </div>  
                     </div>
                }
                
            </div>
        )
    }
}